import postal from 'postal';
import React from 'react';
import { EditTrailBox } from './edit_trail_box';
import { EditTrailEndBox } from './edit_trail_end_box';
import { ContributeMap } from './contribute_map';
import { PageStrings } from '../../../../utils/page_strings_util';
import { LanguageSupportUtil } from '../../../../utils/language_support_util';
import { getFormattedTrailUrls } from '../../../../utils/trail_helpers';

const createReactClass = require('create-react-class');

const ContributeTrailApp = createReactClass({
  getInitialState() {
    this.resultCardFunctions = {
      handleTrailClick: this.handleTrailClick,
      formatTrailUrl: this.formatTrailUrl
    };

    const { trail } = this.props;
    let defaultMap;
    if (trail) {
      defaultMap = trail.defaultMap;
      // Ensure trailId is on the defaultMap
      // (it may not because defaultMap is usually the trail planner map BEFORE being converted to a verified route)
      if (defaultMap && !defaultMap.trailId) {
        // trail_id is given as "id" from trail_medium_presenter
        defaultMap.trailId = trail.id;
      }
    }
    return {
      contributeState: trail ? 'editTrailActive' : 'editTrailStart',
      defaultMap,
      routeInfo: null // in-progress trail planner routeInfo
    };
  },
  handleTrailClick(trail) {
    // Open Trail SEO Pages in new window instead of default behavior (opening up Explore trail page)
    window.open(this.formatTrailUrl(trail), '_blank');
  },
  formatTrailUrl(trail) {
    return getFormattedTrailUrls(trail, this.props.context).localizedUrl;
  },
  handleRouteInfoChanged(routeInfoChanges) {
    if (!routeInfoChanges) {
      this.setState({ routeInfo: null });
      return;
    }
    let { routeInfo } = this.state;
    routeInfo = routeInfo ? { ...routeInfo, ...routeInfoChanges } : routeInfoChanges;
    this.setState({ routeInfo });
  },
  handleMapChange(defaultMap) {
    this.setState({ defaultMap });
  },
  setMapRef(map) {
    // TODO: there is probably a better way to do this, but map is initiated in the component below this,
    // and we need get center and zoom here
    this.contributeMapObj = map;
  },
  endEditTrail() {
    this.setState({ contributeState: 'editTrailEnd' });
  },
  handleAddTrailClick() {
    const contributeMap = this.contributeMapObj;
    const center = contributeMap.getCenter();
    const zoom = contributeMap.getZoom();
    const url = LanguageSupportUtil.wrapUrlSafe(
      `/trail/new?latitude=${center.lat}&longitude=${center.lng}&zoom=${zoom}`,
      this.props.context.languageRegionCode
    );
    window.open(url, '_blank');
  },
  render() {
    // Render welcome, contribute or end box over map
    let contributeBox = null;
    if (this.state.contributeState == 'editTrailActive') {
      contributeBox = (
        <EditTrailBox
          adminUser={this.props.context ? this.props.context.adminUser : null}
          allowNameEditing={this.props.allowNameEditing}
          context={this.props.context}
          currentCity={this.props.currentCity}
          displayMetric={this.props.context ? this.props.context.displayMetric : null}
          handleAddTrailClick={this.handleAddTrailClick}
          key={`editTrail-${this.props.trail.id}`}
          messagingChannel={this.props.messagingChannel}
          nextTrailCallback={this.endEditTrail}
          rapidRoute={this.props.rapidRoute}
          routeInfo={this.state.routeInfo}
          trail={this.props.trail}
          handleMapChange={this.handleMapChange}
          useMapAsRoute={this.state.defaultMap}
        />
      );
    } else if (this.state.contributeState == 'editTrailEnd') {
      contributeBox = <EditTrailEndBox key="editTrailEnd" trail={this.props.trail} />;
    }
    // Convert trail data to Algolia format
    const { id, name, slug, location } = this.props.trail;
    const trailObj = { ID: id, type: 'trail', name, slug };
    let initialCenter;
    if (location && location.zoom) {
      initialCenter = [location.latitude, location.longitude, location.zoom];
    }
    // Render component
    return (
      <div id="contribute-fullscreen" className="full-height">
        {contributeBox}
        <ContributeMap
          context={this.props.context}
          currentPage={PageStrings.CONTRIBUTE_TRAIL}
          exploreMap={this.state.defaultMap}
          handleOverlayToggled={this.handleOverlayToggled}
          id="contribute-map"
          initialCenter={initialCenter}
          mapboxAccessToken={this.props.mapboxAccessToken}
          mapDivId="map"
          mapMatchPolyline={this.props.mapMatchPolyline}
          mapProviderName="mapBox"
          messagingChannel={this.props.messagingChannel}
          plannerMap={this.state.routeInfo ? this.state.routeInfo.plannerMap : null}
          handleRouteInfoChanged={this.handleRouteInfoChanged}
          resultCardFunctions={this.resultCardFunctions}
          selectedObject={trailObj}
          setMapRef={this.setMapRef}
        />
      </div>
    );
  }
});

ContributeTrailApp.defaultProps = {
  messagingChannel: postal.channel('contribute_messagingChannel')
};

export { ContributeTrailApp };
